/** @format */

const template = `
<article ng-if="$ctrl.courseUnit" class="courseunit {{$ctrl.categoryCssClass}}">
  <div class="courseunit-top-row">
    <div class="credits-box">
      <sis-tooltip tooltip-text="{{$ctrl.visibleCredits | creditRangeLong}}" [append-to-body]="true">
        <span
          ng-if="!$ctrl.attainment"
          class="credit-amount sis-tooltip-trigger-content"
          ng-class="{'partial-credit-amount': $ctrl.isPartialCreditAmount}"
          >{{$ctrl.visibleCredits | creditRangeShort}}</span
        >
      </sis-tooltip>
      <sis-tooltip tooltip-text="{{$ctrl.visibleCredits | creditRangeLongAttained}}" [append-to-body]="true">
        <span
          ng-if="$ctrl.attainment"
          class="credit-amount sis-tooltip-trigger-content"
          ng-class="{'partial-credit-amount': $ctrl.isPartialCreditAmount}"
          >{{$ctrl.visibleCredits | creditRangeShort}}</span
        >
      </sis-tooltip>
      <span class="credit-abbreviation" translate="SIS_COMPONENTS.CREDIT_RANGE.CREDITS_ABBR">op</span> </div
    ><!--
     --><div class="grade-box" ng-if="$ctrl.attainment">
      <sis-icon icon="achievement"></sis-icon>
      <span class="grade-text"> {{:: $ctrl.gradeAbbreviation | localizedString }} </span> </div
    ><!--
     --><div ng-if="$ctrl.isSubstitution" class="substitution-indicator-box">
      <sis-tooltip tooltip-text="{{::'STUDIES.SUBSTITUTIONS.IS_SUBSTITUTING_COURSE_UNIT' | translate}}" [append-to-body]="true">
        <sis-popover
          class="sis-tooltip-trigger-content"
          popover-class="substitution-cu-info-popover"
          popover-placement="bottom-left"
          aria-labelledby="{{$ctrl.courseUnitId}}-tooltip">
          <button
            type="button"
            class="link-button sis-popover-trigger-content"
            ng-click="$ctrl.substitutionExpanded = !$ctrl.substitutionExpanded"
            aria-expanded="{{$ctrl.substitutionExpanded}}">
            <sis-icon icon="switch"></sis-icon>
          </button>
          <substitution-info
            class="sis-popover-popover-content substitution-popover"
            course-unit-id="$ctrl.substituteFor"
            validatable-plan="$ctrl.validatablePlan"></substitution-info>
        </sis-popover>
      </sis-tooltip> </div
    ><!--
     --><div class="title-box">
      <span class="courseunit-code">
        <button
          type="button"
          class="link-button"
          ng-if="$ctrl.clickable"
          ng-click="$ctrl.clickAction()"
          aria-label="{{::$ctrl.courseUnit.code}} {{$ctrl.courseUnit.name | localizedString}} {{'ARIA_LABEL.OPEN_INFO' | translate}}">
          <sis-icon icon="brochure"></sis-icon>{{::$ctrl.courseUnit.code}}
        </button>
        <span ng-if="!$ctrl.clickable"><sis-icon icon="brochure"></sis-icon>{{::$ctrl.courseUnit.code}}</span>
        <span
          ng-if="$ctrl.courseUnit.documentState != 'ACTIVE'"
          class="tiny-badge"
          ng-class="{'accent': $ctrl.courseUnit.documentState == 'DRAFT',
                                 'danger': $ctrl.courseUnit.documentState == 'DELETED'}"
          translate="{{'DOCUMENT_STATE.'+$ctrl.courseUnit.documentState}}">
        </span>
      </span>
      <span class="courseunit-title">
        <sis-tooltip [append-to-body]="true" tooltip-class="tooltip-wide">
          <span class="sis-tooltip-trigger-content" aria-label="{{$ctrl.titleAriaLabel}}"
            ><span aria-hidden="true">{{:: $ctrl.courseUnit.name | localizedString }}</span></span
          >
          <div class="sis-tooltip-content plan-structure-study-tooltip">
            <div class="study-name">{{:: $ctrl.courseUnit.name | localizedString }}</div>
            <div class="second-level">
              <div class="second-level-title" translate="SIS_COMPONENTS.PLAN.STUDY_TOOLTIP.CURRICULUM_PERIODS"></div>
              <ul>
                <li ng-repeat="curriculumPeriod in ::$ctrl.curriculumPeriods track by curriculumPeriod.id"
                  >{{ curriculumPeriod.name | localizedString }}</li
                >
              </ul>
            </div>
          </div>
        </sis-tooltip>
      </span> </div
    ><!--
   --><div ng-transclude="additional"></div>
  </div>
  <div class="cu-notification-bar">
    <sis-tooltip
      ng-if="$ctrl.showExpiryWarning && $ctrl.isAttainmentAboutToExpire()"
      tooltip-text="{{'PLAN.COURSE_UNIT.EXPIRATION_IMMINENT' | translate}} {{$ctrl.getAttainmentExpiryDate() | localDateFormat}}">
      <div class="cu-notification sis-tooltip-trigger-content">
        <span class="cu-notification-header"><sis-icon icon="alert-fill"></sis-icon></span
        ><!--
             --><span class="cu-notification-content">
          <span translate="PLAN.COURSE_UNIT.EXPIRATION_IMMINENT"></span>
          {{$ctrl.getAttainmentExpiryDate() | localDateFormat}}.
        </span>
      </div>
    </sis-tooltip>
    <sis-tooltip
      ng-if="$ctrl.isInvalidSelection($ctrl.courseUnit) && !$ctrl.hasModuleContentApproval($ctrl.courseUnit)"
      tooltip-text="{{'PLAN.INVALID_SELECTIONS.NOTIFICATION' | translate}}">
      <div class="cu-notification sis-tooltip-trigger-content">
        <span class="cu-notification-header"><sis-icon icon="alert-fill"></sis-icon></span
        ><!--
             --><span class="cu-notification-content">
          <span translate>PLAN.INVALID_SELECTIONS.NOTIFICATION</span>
        </span>
      </div>
    </sis-tooltip>
    <sis-tooltip
      ng-if="$ctrl.isInvalidAccordingToModuleContentApproval($ctrl.courseUnit)"
      tooltip-text="{{'PLAN.INVALID_ACCORDING_TO_MODULE_CONTENT_APPROVAL.NOTIFICATION' | translate}}">
      <div class="cu-notification sis-tooltip-trigger-content">
        <span class="cu-notification-header"><sis-icon icon="alert-fill"></sis-icon></span
        ><!--
             --><span class="cu-notification-content">
          <span translate>PLAN.INVALID_ACCORDING_TO_MODULE_CONTENT_APPROVAL.NOTIFICATION</span>
        </span>
      </div>
    </sis-tooltip>
    <sis-tooltip
      ng-if="$ctrl.selectedParent"
      tooltip-text="{{'PLAN.COURSE_UNIT.IMPLICIT_IN_MODULE' |translate}} {{ $ctrl.selectedParent.name | localizedString }}"
      [append-to-body]="true">
      <div class="cu-notification sis-tooltip-trigger-content">
        <span class="cu-notification-header"><sis-icon icon="info"></sis-icon></span
        ><!--
             --><span class="cu-notification-content">
          <span>{{'PLAN.COURSE_UNIT.IMPLICIT_IN_MODULE' |translate}} {{ $ctrl.selectedParent.name | localizedString }}</span>
        </span>
      </div>
    </sis-tooltip>
    <div ng-transclude="notifications"></div>
  </div>
</article>
`;
export default template;
